import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { getStaDetail, getStaFeeDetails, getMapStaInfo, } from "@/api/api-operation-service";
import piDetailsItem from "@/components/pi-details-item/pi-details-item.vue";
import piRateChargeCard from "@/components/pi-rate-charge-card/pi-rate-charge-card.vue";
import piRateDelayCard from "@/components/pi-rate-delay-card/pi-rate-delay-card.vue";
import i18n from "@/config/i18n";
import { piThConvertStringToTimes } from "@/utils/time.helper";
let PiSiteDetails = class PiSiteDetails extends Vue {
    constructor() {
        super(...arguments);
        this.nameWidth = "0.84rem";
        this.nameWidthTow = "0.7rem";
        this.piThConvertStringToTimes = piThConvertStringToTimes;
        this.staInfoData = {};
        this.totalDev = 0;
        /**
         * 充电费费率
         */
        this.oprChargeFeeData = {
            feeName: "",
            dcTableList: [],
            acTableList: [],
        };
        // 延时费费率
        this.oprDelayFeeData = {
            feeName: "",
            dcTableList: [],
            acTableList: [],
        };
        this.formInline = {
            type: "",
            city: "",
            userName: "",
            globalPageIndex: 1,
            globalPageSize: 20,
        };
        this.tableListPile = [];
        this.tableColumnsPile = [
            {
                title: i18n.t("commonTableName.serialNumber"),
                key: "serialNumber",
                minWidth: 120,
            },
            {
                title: i18n.t("commonTableName.deviceType"),
                key: "deviceTypeDesc",
                minWidth: 120,
            },
            {
                title: i18n.t("pileInfoDetail.manufacturerName"),
                key: "manufacturerName",
                minWidth: 120,
            },
            {
                title: i18n.t("pileInfoDetail.ratedPower"),
                key: "ratedPower",
                minWidth: 120,
            },
        ];
        this.feeData = {};
    }
    async getDetail() {
        const ret = await getStaDetail({ staPkId: this.staPkId });
        if (ret.status == this["$config"].apiStatus) {
            this.formInline = ret.data[0];
            this.tableListPile = ret.data[0].chargePileVos;
        }
    }
    async getFeeDetail() {
        const ret = await getStaFeeDetails({ staPkId: this.staPkId });
        if (ret.status == this["$config"].apiStatus) {
            const data = ret.data[0] || {};
            this.feeData = data;
            this.oprChargeFeeData = data.concurrentFee || {};
            this.tableDelayData(data.delayFee);
        }
    }
    /**
     * 处理占桩费数据
     */
    tableDelayData(data) {
        if (data) {
            let acTableList = data.oprAcFeeInfos.map((child) => {
                child.freeMinutes = data.acFreeMinutes || "-";
                child.delayFeeUpperLimit = data.acDelayFeeUpperLimit || "-";
                return child;
            });
            let dcTableList = data.oprDcFeeInfos.map((child) => {
                child.freeMinutes = data.dcFreeMinutes || "-";
                child.delayFeeUpperLimit = data.dcDelayFeeUpperLimit || "-";
                return child;
            });
            this.oprDelayFeeData.feeName = data.tplName;
            this.oprDelayFeeData.acTableList = acTableList;
            this.oprDelayFeeData.dcTableList = dcTableList;
        }
        else {
            this.oprDelayFeeData.feeName = "";
            this.oprDelayFeeData.acTableList = [];
            this.oprDelayFeeData.dcTableList = [];
        }
    }
    async getStaInfo() {
        const ret = await getMapStaInfo({ staPkId: this.staPkId });
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data[0];
            this.staInfoData = data;
            const acPileCount = data.acPileCount || 0;
            const dcPileCount = data.dcPileCount || 0;
            this.totalDev = acPileCount + dcPileCount;
        }
    }
    mounted() {
        this.getDetail();
        this.getStaInfo();
        this.getFeeDetail();
    }
};
__decorate([
    Prop({ default: "" })
], PiSiteDetails.prototype, "staPkId", void 0);
PiSiteDetails = __decorate([
    Component({
        components: {
            "pi-details-item": piDetailsItem,
            "pi-rate-charge-card": piRateChargeCard,
            "pi-rate-delay-card": piRateDelayCard,
        },
    })
], PiSiteDetails);
export default PiSiteDetails;
